import { Box, Typography, Grid, Card, CardContent, CardActionArea, useTheme, useMediaQuery } from "@mui/material"
import { Link } from "react-router-dom"
import { IconCalculator, IconCreditCard } from "@tabler/icons-react"

const tools = [
  {
    id: "yanbal-calc",
    title: "Calculadora",
    icon: <IconCalculator size={60} />,
    color: "#FF6B00"
  },
  {
    id: "yanbal-cards",
    title: "Tarjetas",
    icon: <IconCreditCard size={60} />,
    color: "#FF6B00"
  },
]

const ToolsHome = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box>
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          color: theme.palette.primary.main,
          fontWeight: 600,
        }}
      >
        Herramientas
      </Typography>

      <Grid container spacing={3}>
        {tools.map((tool) => (
          <Grid item xs={6} sm={6} md={3} key={tool.id}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                border: `1px solid ${theme.palette.divider}`,
                transition: 'transform 0.2s, box-shadow 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[4]
                }
              }}
            >
              <CardActionArea
                component={Link}
                to={`/tools/${tool.id}`}
                sx={{
                  flexGrow: 1,
                  p: isMobile ? 1.5 : 3,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                <Box
                  sx={{
                    backgroundColor: `${tool.color}15`,
                    color: tool.color,
                    width: 100,
                    height: 100,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 1
                  }}
                >
                  {tool.icon}
                </Box>
                <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                  <Typography
                    variant="h6"
                    component="div"
                    gutterBottom
                    sx={{
                      color: theme.palette.text.primary,
                      fontWeight: 600
                    }}
                  >
                    {tool.title}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default ToolsHome
